export default __webpack_public_path__ + "static/media/uploader-dexcom-4.f0969f35.png";